import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./counter/userSlice"

const store = configureStore({
  reducer: {
    auth: authReducer,
  },
});

export default store;
